<template>
  <div class="contentBox">
    <!-- 表格数据 -->
    <div class="tableBox">
      <!-- 企业兑付 -->
      <div class="innovationVoucher">
        <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
        <span>企业兑付</span>
      </div>
      <!-- Tabs标签组件 -->
      <Tabs :tabs="tabsList" @tab-click="tabClick" :showPagination="true" :pageOptions="pageOptions" @page-change="handlePageChange">
        <template v-if="currentTabsData.length">
          <JRtable
            :table-data="item"
            :selection="false"
            :show-pagination="false"
            :column="currentUsersColumns"
            size="mini"
            :border="true"
            v-for="(item, index) in currentTabsData"
            :key="index"
            :index="true"
          >
            <div class="tabs-header">
              <div class="left">
                <div>{{ item[0].fwflmc }}</div>
                <div>{{ item[0].fwmc }}</div>
              </div>
              <div style="display: flex">
                <template v-if="tabslabel === '待确认'">
                  <el-button type="success" size="small" @click="handleViewExchangeDetails(item[0].dfid, item[0], '处理')">处理</el-button>
                </template>
                <template v-else-if="tabslabel === '确认通过'">
                  <el-button type="danger" size="small" @click="revocation(item[0].dfid)">撤回</el-button>
                  <el-button type="primary" size="small" @click="handleViewExchangeDetails(item[0].dfid, item[0])">查看</el-button>
                </template>
                <template v-else-if="tabslabel === '兑付完成'">
                  <el-button type="primary" size="small" @click="handleViewExchangeDetails(item[0].dfid, item[0])">查看</el-button>
                </template>
                <template v-else>
                  <el-button type="primary" size="small" @click="handleViewExchangeDetails(item[0].dfid, item[0])">查看</el-button>
                </template>
              </div>
            </div>
            <template slot="slot_record_status" slot-scope="data">
              <span v-if="data.scope.row.id7 === 0" style="color: #ff3131">已退回</span>
              <span v-else-if="data.scope.row.id7 === 1" style="color: #24ba2f"> 正在审核 </span>
              <span v-else-if="data.scope.row.id7 === 2" style="color: #24ba2f"> 待补充 </span>
              <span v-else-if="data.scope.row.id7 === 3" style="color: #24ba2f"> 已完成 </span>
              <span v-else></span>
            </template>
          </JRtable>
        </template>
        <template v-else>
          <div style="color: #333333; font-weight: 400; width: 64px; height: 30px; margin: 30px">暂无数据</div>
        </template>
      </Tabs>
      <!-- 企业新增兑付信息弹窗表单 -->
      <Dialog :visible.sync="showDialog" width="1600px" title="企业兑付申请表" :showBtn="false" @close="showDialog = false" :append-to-body="true">
        <template #content>
          <div class="applyform">
            <!-- 修改表单组件 -->
            <component
              :is="test"
              v-if="showDialog"
              @closeDialog="closeDialog"
              :operation="true"
              :operation1="operation1"
              :operation2="operation2"
              :uuid="uuid"
              ref="childRef"
              @getExchangeList="getExchangeList"
              @openDialog2="openDialog2"
            ></component>
          </div>
        </template>
      </Dialog>
      <el-dialog :visible.sync="showDialog2" width="500px"  :show-close="false" class="newDialog">         
        <newDialog :visible.sync="showDialog2" title="审核意见" @closeDialog="closeDialog2" @confirm="confirm" :showCancelBtn="true" :showCloseIcon="false">
          <template v-slot:tb>
            <img src="@/assets/images/approval.png" alt="" />
          </template>
          <!-- 弹窗内容 -->
          <el-input type="textarea" :rows="10" placeholder="请输入审核意见" v-model="textarea"> </el-input>
        </newDialog>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import WelcomeBox from '@/components/WelcomeBox'
import JRtable from '@/components/Table'
import Tabs from '@/components/Tabs'
import Dialog from '@/views/enterprise/components/Dialog'
import exchangeApplyForm from '@/views/applyForm/exchangeApplyForm'
import { getExchangeList, getPageExchangeList, addExchange } from '@/api/enterprise/exchangelist'
import newDialog from '@/components/newDialog'
export default {
  components: {
    WelcomeBox,
    JRtable,
    Tabs,
    Dialog,
    exchangeApplyForm,
    newDialog
  },
  created() {
    // 获取企业兑付记录数量
    this.getExchangeList()
  },
  data() {
    return {
      test: 'exchangeApplyForm',
      // 分页数据
      pageOptions: {
        page: 1,
        limit: 10,
        total: 0,
        // 标签状态（1草稿，2确认通过，3兑付完成，4已驳回）
        dfztMapping: ''
      },
      currentUsersColumns: [
        {
          label: '服务购买方',
          prop: 'fwgmf',
          align: 'center',
          // width: 300,
          truncate: true
        },
        {
          label: '联系人',
          prop: 'fwgmflxr',
          align: 'center',
          truncate: true
        },
        {
          label: '联系方式',
          prop: 'fwgmflxfs',
          align: 'center',
          truncate: true
        },
        {
          label: '合同金额',
          prop: 'htje',
          align: 'center',
          // width: 150,
          truncate: true
        },
        {
          label: '本次预核准兑付金额',
          prop: 'bckdfje',
          align: 'center',
          // width: 150,
          truncate: true
        },
        {
          label: '审核进度',
          align: 'center',
          prop: 'spztName',
          truncate: true
        },
        {
          label: '申报时间',
          prop: 'xgsj',
          align: 'center',
          // width: 200,
          truncate: true
        }
      ],
      // 顶部横向tabs切换栏目
      tabsList: [
        {
          id: 0,
          value: '待确认',
          isActive: true,
          quantity: 0
        },
        {
          id: 1,
          value: '确认通过',
          isActive: false,
          quantity: 0
        },
        {
          id: 2,
          value: '兑付完成',
          isActive: false,
          quantity: 0
        },
        {
          id: 3,
          value: '已驳回',
          isActive: false,
          quantity: 0
        }
      ],
      // tabs当前页的标签名称与描述
      tabslabel: '待确认',
      // 是否显示dialog
      showDialog: false,
      // 四个tabs栏目的数据
      currentTabsData: [],
      // 下拉框的数据
      options: [],
      // 服务机构名称下拉列表
      options1: [],
      // 创新券服务名称下拉列表
      options2: [],
      // 本次使用的创新券下拉列表
      options3: [],
      // 操作环节
      linkCode: '',
      // 兑付状态
      status: '',
      // 当前选中的创新券
      currentCxq: null,
      // 当前的uuid信息
      uuid: '',
      // 信息有误弹窗
      showDialog2: false,
      // 用户输入的审核意见
      textarea: '',
      operation1: false,
      operation2: true
    }
  },
  methods: {
    // 根据审核状态统计企业兑付记录
    async getExchangeList() {
      // 默认回到第一个页签
      this.tabsList.forEach((item, index) => {
        if (index == 0) {
          item.isActive = true
        } else {
          item.isActive = false
        }
      })
      const result = await getExchangeList({groupType: 2})
      if (result.code === 200) {
        // 使用for..in遍历对象
        for (let key in result.data) {
          this.tabsList.map((t) => {
            if (t.value === key) {
              t.quantity = result.data[key]
            }
          })
        }
        // 默认获取第一个草稿件的数据
        this.getPageExchangeList(11)
      } else {
        this.$message.error('系统异常，请稍后再试')
      }
    },
    // tabs栏目点击切换事件
    tabClick(item) {
      this.tabslabel = item.value
      // TODO:根据不同选项卡，请求不同的数据
      switch (item.value) {
        case '待确认': // 待确认
          this.getPageExchangeList(11)
          break
        case '确认通过': // 确认通过
          this.getPageExchangeList(12)
          break
        case '兑付完成': // 兑付完成
          this.getPageExchangeList(13)
          break
        default:
          // 已驳回
          this.getPageExchangeList(14)
          break
      }
    },
    // 分页查询兑付记录
    async getPageExchangeList(id) {
      const result = await getPageExchangeList({
        ...this.pageOptions,
        dfztMapping: id,
        groupType: 2
      })
      if (result.code === 200) {
        let ExchangeList = []
        let resultData = result.data.records
        resultData.forEach((item) => {
          ExchangeList.push([item])
        })
        this.currentTabsData = ExchangeList
        this.pageOptions.total = result.data.total
      } else {
        this.$message.error('系统异常，请稍后再试')
      }
    },
    // 分页控制
    handlePageChange(val) {
      this.pageOptions.page = val.page
      this.pageOptions.limit = val.limit
      switch (this.tabslabel) {
        case '待确认': // 待确认
          this.getPageExchangeList(11)
          break
        case '确认通过': // 确认通过
          this.getPageExchangeList(12)
          break
        case '兑付完成': // 兑付完成
          this.getPageExchangeList(13)
          break
        default:
          // 已驳回
          this.getPageExchangeList(14)
          break
      }
    },
    // 关闭弹窗
    closeDialog() {
      this.showDialog = false
    },
    // 关闭弹窗
    closeDialog2() {
      this.showDialog2 = false
    },
    // 打开弹窗
    openDialog2() {
      this.showDialog2 = true
    },
    // 提交
    confirm() {
      // 提示用户输入审核意见
      if (this.textarea === '') {
        this.$message.warning('请输入审核意见，再进行提交。')
        return // 不执行提交动作
      }
      this.$refs.childRef.submitExchangeForm('信息有误', { linkCode: '003', status: '007', adviceContent: this.textarea })
      this.showDialog2 = false
    },
    // 点击查看详情
    handleViewExchangeDetails(id, item, staus = '查看') {
      if (staus == '查看') {
        this.operation1 = true
        this.operation2 = false
      } else {
        this.operation1 = false
        this.operation2 = true
      }

      // 点击编辑携带过去当前的企业统一社会信用编码
      this.showDialog = true
      this.$nextTick(() => {
        this.uuid = id // 记录uuid
        this.$refs.childRef.editForm(id, item.qytyshxydm)
      })
    },
    // 机构中心查看企业兑付撤回信息
    revocation(id) {
      this.$confirm('此操会将当前信息撤回到待确认, 是否继续?', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        center: true
      })
        .then(() => {
          let addExchangeForm = {
            // 操作环节
            linkCode: '002',
            // 兑付状态
            status: '006',
            // 当前的兑付id
            dfid: id,
            // 当前的审核意见
            adviceContent: '机构撤回'
          }
          // 发起请求
          addExchange(addExchangeForm)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: '撤回成功'
                })
                // 再次获取列表数据
                this.getExchangeList()
              }
            })
            .catch(() => {
              console.log('提交失败')
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/form.scss';
.contentBox {
  width: 100%;
  height: 100%;
  .tableBox {
    margin-top: 25px;
  }
}
.innovationVoucher {
  font-weight: bold;
  display: flex;
  font-size: 20px;
  color: #333333;
  margin-bottom: 15px;
  span {
    margin-left: 10px;
  }
  :nth-child(3) {
    font-size: 16px;
    font-weight: bold;
    color: #ff0000;
    margin-left: 15px;
  }
}
.tabs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 34px;
  .left {
    display: flex;
    :nth-child(1) {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 29px;
      padding: 5px;
      opacity: 0.75;
      background: #3f7fff;
    }
    :nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-left: 17px;
    }
  }
}
.table-container {
  padding: 15px;
  border: 1px solid rgb(243, 247, 255) !important;
  background: rgb(252, 252, 252);
  margin-top: 20px !important;
  margin-bottom: 0px !important;
}
// 企业兑付申请表单样式
.applyform {
  padding: 10px;
  .box-cards {
    margin-bottom: 10px;
    .card-title {
      display: flex;
      align-items: center;
      div {
        width: 5px;
        height: 13px;
        background: rgb(88, 155, 248);
        margin-right: 10px;
      }
      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}

::v-deep .el-form {
  .el-form-item {
    display: flex;
  }
  .el-form-item__content {
    margin-left: 10px !important;
  }
}

::v-deep .columngroup {
  display: flex;
  flex-direction: column;
  .el-radio {
    margin-bottom: 10px;
  }
}

::v-deep .columngroup2 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .el-radio {
    margin-bottom: 10px;
  }
}

::v-deep .columngroup3 {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  .el-radio {
    margin-bottom: 10px;
  }
}
.warnig_text {
  color: red;
  font-weight: bold;
  margin-left: 15px;
  font-size: 16px;
}

::v-deep.upload-attachments {
  .el-card__body {
    .el-row {
      height: 100px;
      border-bottom: 1px solid rgb(205, 211, 220);
      display: flex;
      align-items: center;
      .upload-title {
        font-weight: bold;
        font-size: 16px;
      }
      .upload-icon {
        cursor: pointer;
        font-size: 16px;
        color: rgb(86, 165, 253);
        i {
          margin-right: 5px;
        }
      }
      .upload-waring {
        color: red;
        font-size: 16px;
      }
    }
  }
}
.up-list_item {
  background: rgba(144, 161, 183, 0.06);

  .up-list_item_row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
      background: #f4f5f5;
    }

    .fileName .el-link {
      font-size: 15px;
    }
  }
}
::v-deep .tabs_content {
  background: none !important;
  border: none !important;
}
::v-deep .newDialog{
  .el-dialog {
    height: 0px !important;
  }
}
</style>
